/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineLatest, Observable, ObservableInput, ObservedValueOf, of } from 'rxjs';

// This Observable creator is useful when nesting combineLatests. If an internal combineLatest receives zero arguments,
// or an array of length zero, it will immediately complete without emitting any result. This unfortunately will
// prevent the parent combineLatest from ever emitting a result, even if all the other observables that it combines
// emit results. By releasing a single result and then completing, results from the other branches can flow through.
export function combineLatestOrEmptyArray<O extends ObservableInput<any>>(sources: O[]): Observable<ObservedValueOf<O>[]> {
  return sources.length === 0
    ? of([])
    : combineLatest(sources)
}
